import { render, staticRenderFns } from "./CommentCount.vue?vue&type=template&id=b098548a&"
import script from "./CommentCount.vue?vue&type=script&lang=js&"
export * from "./CommentCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b098548a')) {
      api.createRecord('b098548a', component.options)
    } else {
      api.reload('b098548a', component.options)
    }
    module.hot.accept("./CommentCount.vue?vue&type=template&id=b098548a&", function () {
      api.rerender('b098548a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/items/CommentCount.vue"
export default component.exports